/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React, { Component }                from 'react';
import Helmet                              from 'react-helmet';
import { DefaultPage }                     from '../templates/DefaultPage';
import { StyledContentWrapper }            from '../atoms/StyledContentWrapper';
import { StyledContent }                   from '../atoms/StyledContent';
import { StyledVerticalFlow }              from '../atoms/StyledVerticalFlow';
import { Heading1, Heading2, RegularText } from '../atoms/StyledTypography';
import { HMLandRegistry }                  from '../atoms/HMLandRegistry';
import { TableList }                       from '../molecules/TableList';
import { RegularList }                     from '../molecules/RegularList';
import { ContentIcon }                     from '../molecules/ContentIcon';
import { IconHomeHeart }                   from '../atoms/IconHomeHeart';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export class About extends Component {
    constructor() {
        super();

        this.state = {
            glossary: [
                { title: 'Price', text: 'Sale price stated on the transfer deed.' },
                { title: 'Date', text: 'Date when the sale was completed, as stated on the transfer deed.' },
                {
                    title: 'Type',
                    text: `On the date of completion, whether the property was 'Detached', 'Semi-Detached', 'Terraced',
                     'Flats/Maisonettes' or 'Other'. Note that HM Land Registry does not identify 'Bungalows'
                     separately.`
                },
                {
                    title: 'Age',
                    text: `On the date of completion , whether the property was newly built or an established
                    residential building.`
                },
                {
                    title: 'Tenure',
                    text: `Freehold or leasehold or unknown. Note that HM Land Registry does not record leases of
                    7 years or less in the Price Paid Dataset.`
                },
                {
                    title: 'Category',
                    text: `There are two categories groups for transaction. Category 'A' is 'Standard Price Paid' and
                    relates to  single residential property sold for full market value. Category 'B' is
                    'Additional Price Paid' and relates to transfers under a power of sale/repossessions,
                    buy-to-lets (where they can be identified by a Mortgage) and transfers to non-private individuals.
                    Note that category 'B' does not separately identify the transaction types stated. HM Land Registry
                    has been collecting information on category 'A' transactions from January 1995. Category 'B'
                    transactions were identified from October 2013.`
                }
            ],
            exclusions: [
                { text: 'Sales that have not been lodged with HM Land Registry' },
                {
                    text: 'Sales that were not for full market value. By this we mean, the sale of part of a property, a share of a property or the sale of a property at a discount. For example, a transfer between parties on divorce transfers, conveyances, assignments or leases at a premium with nominal rent which are:',
                    children: [
                        { text: '\'Right to buy\' sales at a discount' },
                        { text: 'Subject to an existing mortgage' },
                        { text: 'To effect the sale of a share in a property' },
                        { text: 'By way of a gift' },
                        { text: 'Under a compulsory purchase order' },
                        { text: 'Under a court order' },
                        { text: 'To Trustees appointed under Deed of appointment' },
                    ]
                },
                { text: 'Vesting Deeds Transmissions or Assents of more than one property' }
            ]
        };
    }

    render() {
        return (
            <DefaultPage>
                <Helmet title="About Us | Price Paid Data"/>
                <StyledContentWrapper>
                    <StyledContent>
                        <StyledVerticalFlow>
                            <Heading1>About Price Paid Data</Heading1>
                        </StyledVerticalFlow>
                        <StyledVerticalFlow>
                            <RegularText>Price Paid Data is an application that aims to enable users to easily search
                                through and filter all the available property sold prices data provided by the Land
                                Registry to a granular degree. Price Paid Data specifically focuses on property
                                transactions and as a result accurate insights and trends can be derived for the England
                                and Wales property market. The source data is produced by HM Land Registry &copy; Crown
                                copyright 2017.</RegularText>
                        </StyledVerticalFlow>
                        <StyledVerticalFlow>
                            <HMLandRegistry/>
                        </StyledVerticalFlow>
                        <StyledVerticalFlow>
                            <Heading1>Data considerations</Heading1>
                        </StyledVerticalFlow>
                        <StyledVerticalFlow>
                            <RegularText>The data available on Price Paid Data is synchronised with the data from HM
                                Land Registry and it will be available on the site the same day. New data is published
                                by HM Land Registry on the 20th working day of each month and that data relates to the
                                preceding month.</RegularText>
                        </StyledVerticalFlow>
                        <StyledVerticalFlow>
                            <Heading2>Transaction data</Heading2></StyledVerticalFlow>
                        <StyledVerticalFlow>
                            <RegularText>The amount of time between the sale of a property and the registration of this
                                information with HM Land Registry varies. It typically ranges between 2 weeks and 2
                                months. Data for the two most recent months is therefore incomplete and does not give an
                                indication of final monthly volumes. Occasionally the interval between sale and
                                registration is longer than two months. The small number of sales affected cannot be
                                updated for publication until the sales are lodged for registration.</RegularText>
                        </StyledVerticalFlow>
                        <StyledVerticalFlow>
                            <Heading2>Transaction details explained</Heading2>
                        </StyledVerticalFlow>
                        <StyledVerticalFlow>
                            <TableList items={this.state.glossary}/>
                        </StyledVerticalFlow>
                        <StyledVerticalFlow>
                            <Heading2>Data excluded from Price Paid Data</Heading2>
                        </StyledVerticalFlow>
                        <StyledVerticalFlow>
                            <RegularText>HM Land Registry data includes information on all residential property sales in
                                England and Wales that are sold for full market value and are lodged with us for
                                registration. This data excludes:</RegularText>
                        </StyledVerticalFlow>
                        <StyledVerticalFlow>
                            <RegularList items={this.state.exclusions}/>
                        </StyledVerticalFlow>
                        <ContentIcon icon={<IconHomeHeart/>}/>
                    </StyledContent>
                </StyledContentWrapper>
            </DefaultPage>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/About.js